import Debug from '@tiger/debug';
import { Button, Form } from 'antd';
import React, { useLayoutEffect, useState } from 'react';
import { useForm, withForm } from 'react-antd-formutil';
import { useNavigate } from 'react-router-dom';
import Card, { CardButtonWrap } from 'components/Card';
import Email from 'components/forms/Email';
import TelcodePhoneVerify from 'components/forms/TelcodePhoneVerify';
import TelPhone from 'components/forms/TelPhone';
import TabNav from 'components/TabNav';
import Toast from 'components/Toast';
import VerifyCodeSend from 'components/VerifyCodeSend';
import security from 'stores/security';
import API from 'utils/API';
import http from 'utils/http';
import URL from 'utils/URL';

const type = URL.current().query.loginType;

const PasswordVerify: React.FC = () => {
    const [tab, setTab] = useState<'phone' | 'email'>(type === 'phone' ? 'phone' : 'email');
    const navigate = useNavigate();
    const $formutil = useForm<{ email: string; phone: string; tel_code: string }>();
    const onTabChange = val => {
        setTab(val === 1 ? 'phone' : 'email');
    };

    useLayoutEffect(() => {
        // 重置密码，强制清除用户登录信息
        security.clearAuth();
    }, []);

    const submit = async () => {
        const { $params, $invalid, $getFirstError, $batchDirty } = $formutil;

        if ($invalid) {
            Toast.show($getFirstError());
            $batchDirty(true);
        } else {
            Toast.loading(true);

            try {
                const resp = await http.post(
                    tab === 'email' ? API.OAUTH.verifyEmailCode() : API.OAUTH.verifyPhoneCode(),
                    {
                        process: 'reset_login_password',
                        ...$params
                    }
                );

                navigate(`../reset`, {
                    state: {
                        verify_token: resp.data.verify_token,
                        grant_type: tab,
                        email: $formutil.$params.email,
                        phone: $formutil.$params.phone,
                        tel_code: $formutil.$params.tel_code
                    }
                });
            } catch (err) {
                // 操作时长过长
                if (err.error_code === 11084) {
                    navigate('../verify');
                }

                Toast.show(err);
            }

            Toast.loading(false);
        }
    };

    return (
        <Card form>
            <Form layout="vertical" colon={false} onFinish={submit} className="verify-content">
                <h3>{__('选择验证方式')}</h3>
                <TabNav
                    navs={[{ name: __('邮箱') }, { name: __('手机') }]}
                    onClick={onTabChange}
                    activeIndex={tab === 'phone' ? 1 : 0}
                    className="mb-5 select-way-box"
                />
                {tab === 'email' ? (
                    <>
                        <Email name="email" label={__('Please enter your email address')} />
                        <VerifyCodeSend
                            type="email"
                            username={$formutil.$errors.email ? '' : $formutil.$params.email}
                            process="reset_login_password"
                            logined={!!security.ACCESS_TOKEN}
                        />
                    </>
                ) : (
                    <>
                        <TelPhone label={__('Please enter your phone number')} />
                        <TelcodePhoneVerify process="reset_login_password" logined={!!security.ACCESS_TOKEN} />
                    </>
                )}

                <CardButtonWrap className="mt-5">
                    <Button htmlType="submit" block type="primary" size="large">
                        {__('Verify')}
                    </Button>
                </CardButtonWrap>
                <Debug data={$formutil.$params} />
            </Form>
        </Card>
    );
};

export default withForm(PasswordVerify);
